GroupInfoHeaderCtrl = ($scope ,$location ,$filter ) ->
  infoHeaderCtrl = this

  infoHeaderCtrl.displayPrivacy = (privacy) ->
    if privacy
    then $filter('translate')('_GROUP.LIST.PUBLIC_GROUP')
    else $filter('translate')('_GROUP.LIST.PRIVATE_GROUP')

  infoHeaderCtrl.displayMember = (member) ->
    ($filter('translate')('_GROUP.LIST.MEMBERS')) + ': ' + member + ($filter('translate')('_GROUP.LIST.MEMBERS_EXT'))

  infoHeaderCtrl.editGroup =  ->
    $location.path('/groups/' + $scope.groupInfo.id + '/edit')

  infoHeaderCtrl

GroupInfoHeaderCtrl.$inject = [
  '$scope'
  '$location'
  '$filter'
]

module.exports = GroupInfoHeaderCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-info/group-info-header-controller.coffee